import { render, staticRenderFns } from "./ReportTabs.vue?vue&type=template&id=50c7a0de&lang=pug&"
import script from "./ReportTabs.vue?vue&type=script&lang=js&"
export * from "./ReportTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports